'use client'

import { useEffect } from 'react'
import { useSession } from 'next-auth/react'

import {
  CustomerTypes,
  extractCustomerFromClientSession
} from 'modules/customer'
import { useTriggerOnce } from 'shared/hooks/useTriggerOnce'
import { isNotNilOrEmpty } from 'shared/utils/ramda'

import { viewCartSeo } from '../analytics'
import { Cart } from '../types'

const useCartAnalytics = (cart: Cart | null) => {
  const session = useSession()
  const [triggerOnce] = useTriggerOnce()
  const user: CustomerTypes | undefined = extractCustomerFromClientSession(session)

  useEffect(() => {
    if (session.status === 'loading' || !cart?.items) return

    const cartItems = cart?.items || []

    if (isNotNilOrEmpty(cartItems)) {
      triggerOnce(() =>
        viewCartSeo({
          user,
          cart
        })
      )
    }
  }, [session.status, cart, triggerOnce, user])
}

export default useCartAnalytics
